import React, { useEffect, useMemo } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import { useUser } from "./UserContext";
import { Skeleton } from "@postcheesy/ui-lib/molecules";

interface PrivateRouteProps {
  element: React.ReactElement;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
  const { user, loading, isUserChecked, refreshUser, isActive } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("isAuthenticated")) {
      navigate(ROUTES.LOGIN, { replace: true });
      return;
    }

    if (!isUserChecked && !loading && !user) {
      refreshUser();
    }
  }, [user, loading, isUserChecked, refreshUser]);

  const redirectPath = useMemo(() => {
    if (!isUserChecked) return null; 
    if (!user) return ROUTES.LOGIN;
    if (!user.isEmailConfirmed) return ROUTES.CONFIRM_EMAIL;
    if (!user.isPhoneConfirmed) return ROUTES.VERIFY_PHONE;
    if (!isActive) return ROUTES.PROFILE_SETUP;
    return null;
  }, [user, isUserChecked, isActive]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <Skeleton className="w-16 h-16 rounded-full" />
      </div>
    );
  }

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return element;
};

export default PrivateRoute;